import React from 'react';

import LandingPageTypeContext from 'components/shared/LandingPage/contexts/LandingPageTypeContext';
import { LandingBlock } from 'components/shared/LandingPage/RightSide/LandingBlock';
import { LandingBlockProps } from 'components/shared/LandingPage/RightSide/LandingBlock/types';

import * as types from './types';

const ChildrenBlocks = ({
  blockId = '',
  blocks,
  onAddBlock,
  onUpdateBlock,
  onDeleteBlock,
}: types.ChildrenBlocksProps) => {
  const blockerRef = React.useRef<any>();
  let spoilerBlockIndex = -1;
  const visibleSpoilerBlockIndex = React.useRef(-1);
  const firstBlockerRendered = React.useRef(false);

  const { disableFirstSectionNameRemoval } = React.useContext(LandingPageTypeContext);

  const pageHeadlineRef = React.useRef<HTMLDivElement | null>(null);

  return (
    <>
      {blocks.map((block, index) => {
        spoilerBlockIndex++;

        const landingBlockProps: LandingBlockProps = {
          block,
          blockId,
          blockIndex: spoilerBlockIndex,
          visibleBlockIndex: visibleSpoilerBlockIndex,
          isNextBlocked: false,
          firstBlockerRendered,
          pageHeadlineRef,
          blockerRef,

          blockActions: { onDeleteBlock, onUpdateBlock, onAddBlock },

          typeContextProps: { blockAddingAvailable: true, disableFirstSectionNameRemoval },
        };

        const key = block?.id ?? block?.originalId ?? `${spoilerBlockIndex} + ${index}`;

        return <LandingBlock key={key} {...landingBlockProps} isInsideAccordion />;
      })}
    </>
  );
};

export { ChildrenBlocks };
